import layout from '@/layout'

export default {
  path: '/hsgt',
  component: layout,
  redirect: '/hsgt/lgt_row',
  name: 'hsgtLgtCol',
  meta: {
    title: 'hsgt',
    icon: 'hsgt'
  },
  children: [
    {
      path: '/hsgt/lgt_col',
      name: 'hsgtLgtCol',
      component: () => import('@/views/lgt/col'),
      meta: {
        title: 'hsgtLgtCol',
        icon: 'hsgt_lgt'
      }
    }
  ]
}
